import React, {useCallback} from "react";
import SupportGuideHeader from "../../components/SupportGuideHeader";
import {useNavigation} from "@react-navigation/native";
import TermsAndConditionsContent from "./TermsAndConditionsContent";
import {NativeStackNavigationProp} from "@react-navigation/native-stack";
import {isFullSwing} from "../../constants";
import FSHeader from "../../components/FSHeader";
import {colors} from "../../assets/styles/colors";

type Props = { onExit?: () => void };

const TermsAndConditionsScreen = ({onExit: onExitOverride}: Props = {}) => {
  const navigation: NativeStackNavigationProp<any> = useNavigation();

  const onExit = useCallback(() => {
    if (onExitOverride) {
      onExitOverride();
      return;
    }

    if (navigation.canGoBack()) navigation.goBack();
    else navigation.navigate('challenges');
  }, [navigation, onExitOverride]);

  return (
    <>
      {isFullSwing ? (
        <FSHeader
          title="Terms and Conditions" goBack={onExit} hideLogo hideGameLogo hideAccount hideBalance hideMenu px={20}
        />
      ) : (
        <SupportGuideHeader title="Terms and Conditions" onExit={onExit}/>
      )}

      <TermsAndConditionsContent px={10} pb={30} bg={isFullSwing ? 'transparent' : colors.bg_contest}/>
    </>
  );
};

export default TermsAndConditionsScreen;
